// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mpcfZ","right":"styles_right__3LWSy"};